export { default } from "ember-stereo/helpers/pause-sound";
